import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const TooltipWrapper = styled.div`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const TooltipTitle = styled(Typography.TextBody_12_18)(
    ({ theme: { fontWeight, palette } }) => css`
        color: ${palette.neutral.white};
        font-weight: ${fontWeight.bold};
        text-transform: uppercase;
    `,
);

export const TaskItem = styled.span`
    align-items: flex-start;
    display: flex;
    flex-direction: column;
`;

export const TaskText = styled(Typography.TextBody_12_18)(
    ({ theme: { palette } }) => css`
        color: ${palette.neutral.white};
    `,
);

export const TaskDetails = styled.span`
    display: flex;
    gap: 4px;
`;

export const DueDate = styled(Typography.TextBody_12_18)<{
    isDueDatePassed: boolean;
}>(
    ({ isDueDatePassed, theme: { palette } }) => css`
        color: ${isDueDatePassed
            ? palette.semantic.error
            : palette.priority.medium};
    `,
);

export const AdditionalLabelDetails = styled.span`
    align-items: center;
    display: flex;
    gap: 2px;
    justify-content: center;
`;
